import "./ConventionJobAndObjective.scss";

export default {
  root: "im-convention-job-and-objective",
  list: "im-convention-job-and-objective__list",
  item: "im-convention-job-and-objective__item",
  illustration: "im-convention-job-and-objective__illustration",
};
